<template>
  <b-table :hoverable="hoverable" paginated :per-page="perPage" v-bind="$attrs" v-on="$listeners">
    <slot />
  </b-table>
</template>

<script>
export default {
  name: 'AppPaginatedTable',
  inheritAttrs: false,
  props: {
    perPage: {
      type: Number,
      default: 8,
    },
    hoverable: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
